import { CardCellType } from 'layouts/Header/components/Search/types';
import { BannerType } from 'layouts/Header/components/Search/blocks/BannersBlock/Banner/types';

export const getCardKey = ({ id, title }: CardCellType) => id || String(title);
export const getBannerKey = ({ title }: BannerType) => String(title);
